module.exports = __webpack_public_path__ + "static/media/excel-white.aa9991be.svg";